import { Box, Flex, FormControl, FormLabel, Grid, Switch } from '@chakra-ui/react'
import type { TravelInsuredDto } from 'BrokerTsLib/src/dtos'
import { useFormContext } from 'BrokerTsLib/src/rhf'
import moment from 'moment'
import { useMemo } from 'react'

import { ConfirmRemoveButton } from '@/components/ConfirmRemoveButton'
import { InputGroup } from '@/components/InputGroup'
import { ReactHookFormDatepicker as Datepicker } from '@/containers/forms/Datepicker'

import type { AdditionalInsureeRowProps } from './InsureesForm'

export const InsureeRow = ({
  prefix,
  person,
  contracted,
  remove,
  originalIndex,
  editableBirthdate = false,
  editableBirthnumber = false
}: AdditionalInsureeRowProps) => {
  const { getValues, register, setValue, getFieldState, watch } = useFormContext()
  const insurees = getValues(prefix) as TravelInsuredDto[] ?? []

  const index = useMemo(() => {
    // puvodne se index predaval z InsureesForm, ale z nejakeho duvoly byly jine indexy v useFieldArray a v getValues. Vysledkem bylo, ze se osoby michaly a nefungovalo to spravne.
    return insurees.findIndex(x => x.uid == person.uid)
  }, [insurees.length])

  const isPh = person.isPolicyHolder//watch(`${prefix}.${index}.isPolicyHolder`)
  const isForeigner = watch(`${prefix}.${index}.isForeigner`) ?? false

  const firstName = watch(`${prefix}.${index}.firstName`)
  const lastName = watch(`${prefix}.${index}.lastName`)
  const birthnumber = watch(`${prefix}.${index}.birthnumber`)

  const firstNameError = getFieldState(`${prefix}.${index}.firstName`).error
  const lastNameError = getFieldState(`${prefix}.${index}.lastName`).error
  const birthnumberError = getFieldState(`${prefix}.${index}.birthnumber`).error
  const birthdateError = getFieldState(`${prefix}.${index}.birthdate`).error

  const sanitizeRc = (value: string) => {
    return value.replace(/\D/g, '')
  }

  const now = new Date()

  return (
    <Flex
      sx={{
        columnGap: 8,
        alignItems: 'center'
      }}
    >
      <FormControl isRequired={editableBirthnumber && !isPh} isInvalid={!!firstNameError}>
        <FormLabel>Jméno</FormLabel>

        <InputGroup
          htmlSize={12}
          placeholder="Jan"
          isDisabled={!!isPh || contracted}
          errors={firstNameError}
          {...register(`${prefix}.${index}.firstName`)}
          // onChange={(e) => {
          //     setValue(`${prefix}.${index}.firstName`, e.target.value)
          // }}
          value={firstName}
        />
      </FormControl>

      <FormControl isRequired={editableBirthnumber && !isPh} isInvalid={!!lastNameError}>
        <FormLabel>Příjmení</FormLabel>

        <InputGroup
          htmlSize={12}
          placeholder="Novák"
          isDisabled={!!isPh || contracted}
          errors={lastNameError}
          {...register(`${prefix}.${index}.lastName`)}
          value={lastName}
        />
      </FormControl>

      {editableBirthnumber &&
                <FormControl isInvalid={!!birthnumberError}>
                  <FormLabel>Rodné číslo</FormLabel>
                  <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                    <Switch
                      isDisabled={!!isPh || contracted}
                      isChecked={isForeigner}
                      onChange={(e) => setValue(`${prefix}.${index}.isForeigner`, e.target.checked)}
                    />
                    <FormLabel htmlFor={`${prefix}.${index}.isForeigner`} variant="switch">
                      Nemá
                    </FormLabel>

                    {!isForeigner &&
                            <InputGroup
                              htmlSize={12}
                              ml={2}
                              isDisabled={!!isPh || contracted}
                              errors={birthnumberError}
                              {...register(`${prefix}.${index}.birthnumber`, {
                                setValueAs: v => sanitizeRc(v)
                              })}
                              onChange={(e) => setValue(`${prefix}.${index}.birthnumber`, sanitizeRc(e.target.value).toString())}
                              value={birthnumber}
                            />}
                  </Box>
                </FormControl>
      }

      <FormControl isRequired={editableBirthdate && !isPh} isInvalid={!!birthdateError}>
        <FormLabel htmlFor={`${prefix}.${index}.birthdate`}>
          Datum narození
        </FormLabel>

        <Datepicker
          isDisabled={!editableBirthdate || !!isPh || contracted}
          name={`${prefix}.${index}.birthdate`}
          htmlSize={12}
          options={{
            minDate: moment(now).add(-120, 'year').toDate(),
            maxDate: now
          }}
        />
      </FormControl>

      {!editableBirthnumber && !contracted && !isPh &&
                <Grid sx={{ h: '100%', alignSelf: 'start', mt: 9 }}>
                  <ConfirmRemoveButton
                    hideCancelButton
                    fullWidth={true}
                    defaultLabel='X'
                    onClick={() => remove(originalIndex)} />
                </Grid>
      }
    </Flex>
  )
}
